.toast-container {
    position: fixed;
    inset-inline-start: var(--s-30);
    bottom: var(--s-40);
    width: 400px;
    z-index: 10050;
}

.toast {
    display: flex;
    width: 100%;
    border-radius: 5px;
    background-color: var(--c-white);
    border-inline-start: 4px solid var(--c-grey-600);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -2px rgba(0, 0, 0, 0.05);
    padding: var(--s-12) var(--s-15);
    margin-top: var(--s-12);

    &__inner {
        display: flex;
        width: 100%;
    }

    &__close {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
        width: 36px;
        background-size: 20px 20px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512'%3E%3Cpath fill='%23424242' d='M243 256l100-100c12-12 12-32 0-45l-22-22a31 31 0 00-45 0L176 189 76 89a31 31 0 00-45 0L9 111a31 31 0 000 45l100 100L9 356a31 31 0 000 45l22 22c13 12 33 12 45 0l100-100 100 100c12 12 32 12 45 0l22-22c12-13 12-33 0-45L243 256z'/%3E%3C/svg%3E");
        cursor: pointer;
    }

    &__message-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        padding: 0 var(--s-7);
        word-break: break-word;
    }

    &__heading,
    &__message {
        margin: var(--s-3) 0;
        color: var(--c-grey-800);
    }

    &--info {
        border-color: var(--c-primary);
    }

    &--error {
        border-color: var(--c-red);
    }

    &--warning {
        border-color: var(--c-orange);
    }

    &--success {
        border-color: var(--c-green);
    }
}
